import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { apiGetById } from '../../services/genesisApi/httpsMethods';
import { ContactDetail } from './Contact';
import type { FC } from 'react';
import type { Contact } from '../../types/deal';
import { SimpleToolbar } from '../../components/layout/Toolbar';
import { CustomButton } from '../../components/common/customButton';


interface ContactWrapperProps {
  id?: number;
}

const ContactWrapper: FC<ContactWrapperProps> = ({ id }) => {
  const navigate = useNavigate();
  const params = useParams<{ contactId?: string }>();
  const contactId = id ?? (params.contactId ? parseInt(params.contactId) : undefined);

  const [contact, setContact] = useState<Contact | null>(null);

  useEffect(() => {
    if (!contactId) return;

    apiGetById('contact', contactId)
      .then((data) => {
        setContact(data.data[0]);
      })
      .catch((err) => {
        console.error('Failed to fetch contact', err);
      });
  }, [contactId]);

  if (!contactId) return <Typography>Contact ID not found.</Typography>;
  if (!contact) return <Typography>No contact found.</Typography>;

  return (
    <Box sx={{ position: 'relative', zIndex: 1 }}>
      <Box
        sx={{
          position: 'sticky',
          zIndex: 10,
        }}
      >
        <SimpleToolbar>
          <CustomButton
            handleButtonPress={() => { navigate(`/contacts/${contactId}/edit`); }}
            isButtonDisabled={false}
            text="Edit Contact"
            isLoading={false}
            isLoadingText="Loading"
            solid={false}
            widthOverride="100px"
            data-position="right"
          />
        </SimpleToolbar>
      </Box>
      <Box sx={{ padding: 2, marginBottom: 100, zIndex: 100 }}>
        <ContactDetail contact={contact} isEdit={true} isDealPage={false} />
      </Box>
    </Box>
  );
};

export default ContactWrapper;
